import { render, staticRenderFns } from "./PersonListView.vue?vue&type=template&id=59d66ac6&scoped=true&"
import script from "./PersonListView.vue?vue&type=script&lang=ts&"
export * from "./PersonListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d66ac6",
  null
  
)

export default component.exports